import styled from "styled-components";

export const MenuContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  padding: 8px;

  h1 {
    margin-bottom: var(--margin-xl);
    text-transform: uppercase;
  }

  div.menu-item {
    width: 50%;
    max-width: 600px;
    text-align: center;
    background-color: var(--color-purple);
    color: #fff;
    padding: 8px;
    margin-bottom: 8px;
    cursor: pointer;

    h2 {
      font-size: 1em;
    }
  }

  @media screen and (min-width: 768px) {
    padding: 16px;

    div.menu-item {
      padding: 16px;

      h2 {
        font-size: 1.4em;
      }
    }
  }
`;
